import { EmailServerConfig } from 'types/emailServer'

/**
 * BNEP-4502: the domains persisted as the account's email servers were already created and verified by a previous
 * ms-verify-domain call, e.g. before an OAuth consent that the user cancelled. Verifying them again fails with
 * "already verified", so they are neither offered for selection again nor sent for verification again.
 */
export const getVerifiedDomainNames = (emailServers?: EmailServerConfig[] | null): string[] =>
  (emailServers || [])
    .map(emailServer => emailServer.domainName)
    .filter((domainName): domainName is string => !!domainName)

export const excludeVerifiedDomains = (domains: string[], verifiedDomainNames: string[]): string[] =>
  domains.filter(domain => !verifiedDomainNames.includes(domain))
